import { render } from "./SkeletonSummary.vue?vue&type=template&id=f46c12de"
import script from "./SkeletonSummary.vue?vue&type=script&lang=js"
export * from "./SkeletonSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__